import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-online-fees',
  templateUrl: './fees.component.html',
  styleUrls: ['./fees.component.scss']
})
export class FeesComponent implements OnInit {

  schoolId:any;
  url:any;
  sanitizedUrl:any;
    constructor(private sanitizer: DomSanitizer) { }
    ngOnInit(): void {
      if(sessionStorage.getItem("schoolId"))
      {
        
        this.schoolId = sessionStorage.getItem("schoolId");
        console.log("schoolid" + this.schoolId);
        this.url=environment.feeUrl+this.schoolId;
        this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
        console.log(this.sanitizedUrl);
      }
      
      
    };

    feeLink:any;

    openLink(url:any) {
        this.feeLink = this.sanitizer.bypassSecurityTrustResourceUrl(
          url
        )
      }

}
